export default {
  // exportIndexFlowTags(st) {
  //   return st.indexFlowTags;
  // },
  // exportIndexFlowType(st) {
  //   return st.indexFlowType;
  // },
  // exportIndexFilterType(st) {
  //   return st.indexFilterType;
  // },
  // exportIndexFlowTypeArticle(st) {
  //   return st.indexFlowArticle;
  // },
  // exportIndexFlowTypeScoop(st) {
  //   return st.indexFlowScoop;
  // },
  // exportIndexFlowTypeResume(st) {
  //   return st.indexFlowResume;
  // },
  exportIndexOverviewMode(st) {
    return st.indexOverviewMode;
  },
  exportPostBasicOption(st) {
    return st.postBasicOption;
  },
  exportPostCoreOption(st) {
    return st.postCoreOption;
  },
  exportPostCheckPass(st) {
    return st.postCheckPass;
  },
  exportPostErrorText(st) {
    return st.postErrorText;
  },
  exportPostValue(st) {
    return st.postValue;
  },
};
